import styles from "./CheckBox.module.css"
/**
* Props for the Checkbox component.
*/ 
interface CheckBoxTypes {
    text?: string, // Checkbox label
    disabled?: boolean, // Whether checkbox is disabled
    isCircle?: boolean, // Whether checkbox should be a circle
    onCheck?: () => void, // Check event handler
    checked?: boolean // Whether checkbox is checked
}
/**
* A checkbox component with optional label and customization.
*
* @param props CheckBox props
* @param {string} props.text - Checkbox label
* @param {boolean} props.disabled - Whether checkbox is disabled
* @param {boolean} props.isCircle - Whether checkbox should be a circle
* @param {() => void} props.onCheck - Check event handler
* @param {boolean} props.checked - Whether checkbox is checked
* @returns TSX.Element
*/
const CheckBox = ({ text, disabled = false, isCircle = false, onCheck, checked} : CheckBoxTypes) => {
    return(
        <>
            <input type="checkbox" className={`${styles.Checkbox} ${isCircle && styles.Circle}`} disabled={disabled} onChange={onCheck && onCheck} checked={checked && checked} />
            {text && <div className={styles.CheckBoxText}><p>{text}</p></div>}
        </>
    )
};
export default CheckBox;